import { render, staticRenderFns } from "./CountdownBanner.vue?vue&type=template&id=cdddb7d6"
import script from "./CountdownBanner.vue?vue&type=script&lang=js"
export * from "./CountdownBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports